import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05e64a66&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e64a66')) {
      api.createRecord('05e64a66', component.options)
    } else {
      api.reload('05e64a66', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05e64a66&", function () {
      api.rerender('05e64a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/screens/LeasesScreen/index.vue"
export default component.exports